import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import { RadioGroup } from "radix-ui";

export function RadioGroupItem({ children, ...props }: RadioGroup.RadioGroupItemProps) {
	return (
		<RadioGroup.Item
			{...props}
			className={cn(
				"group relative flex h-full w-full cursor-pointer items-center justify-center rounded border-2 border-transparent py-2 text-center leading-[1.375rem] focus:outline-none motion-safe:transition",
				"rdx-state-checked:border-success bg-shades-light rdx-state-checked:bg-white",
				"hover:border-primary-medium hover:bg-white focus-visible:border-primary-medium focus-visible:bg-white",
			)}
		>
			<div className="-right-2.5 -top-2.5 absolute hidden h-5 w-5 items-center justify-center rounded-full bg-success text-[12px] text-white leading-none group-rdx-state-checked:flex">
				<FontAwesomeIcon icon={faCheck} />
			</div>

			{children}
		</RadioGroup.Item>
	);
}
